export const getAlphaConfig = (callbackURL: string) => {
  return {
    Auth: {
      Cognito: {
        userPoolClientId: "35t6ffus0f8779aidpqvcj3slj",
        userPoolId: "us-east-1_qzm6gVTsT",
        loginWith: {
          // Optional
          oauth: {
            domain: "finn-alpha.auth.us-east-1.amazoncognito.com",
            scope: ["openid"],
            redirectSignIn: callbackURL,
            redirectSignOut: callbackURL,
            responseType: "code",
          },
          username: "true",
          email: "false", // Optional
          phone: "false", // Optional
        },
      },
    },
    oauth: {
      domain: "finn-alpha.auth.us-east-1.amazoncognito.com",
      scope: ["openid"],
      redirectSignIn: callbackURL,
      redirectSignOut: callbackURL,
      responseType: "code",
    },

    // Cognito options
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:79093c63-0bdb-4e21-a20e-739b065f7089",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_qzm6gVTsT",
    aws_user_pools_web_client_id: "35t6ffus0f8779aidpqvcj3slj",
    // AppSync
    aws_appsync_graphqlEndpoint:
      "https://3xvtg6hd25clvplgknf4oabkdi.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    API: {
      graphql_endpoint:
        "https://3xvtg6hd25clvplgknf4oabkdi.appsync-api.us-east-1.amazonaws.com/graphql",
      graphql_headers: async () => ({ Authorization: "", AuthUser: "" }),
    },
  };
};
export const getGammaConfig = (callbackURL: string) => {
  return {
    Auth: {
      Cognito: {
        userPoolClientId: "32vqkpkihicso4gpnc62hfsqf3",
        userPoolId: "us-east-1_sfxbMXDYf",
        loginWith: {
          // Optional
          oauth: {
            domain: "finn-gamma.auth.us-east-1.amazoncognito.com",
            scope: ["openid"],
            redirectSignIn: callbackURL,
            redirectSignOut: callbackURL,
            responseType: "code",
          },
          username: "true",
          email: "false", // Optional
          phone: "false", // Optional
        },
      },
    },
    oauth: {
      domain: "finn-gamma.auth.us-east-1.amazoncognito.com",
      scope: ["openid"],
      redirectSignIn: callbackURL,
      redirectSignOut: callbackURL,
      responseType: "code",
    },
    // Cognito options
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:dbf31438-5bd8-42f2-8d23-18a8307da84f",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_sfxbMXDYf",
    aws_user_pools_web_client_id: "32vqkpkihicso4gpnc62hfsqf3",
    // AppSync
    aws_appsync_graphqlEndpoint:
      "https://nebmelp2nfakho4k3a6ydexeu4.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    API: {
      graphql_endpoint:
        "https://nebmelp2nfakho4k3a6ydexeu4.appsync-api.us-east-1.amazonaws.com/graphql",
      graphql_headers: async () => ({ Authorization: "", AuthUser: "" }),
    },
  };
};
export const getProdConfig = (callbackURL: string) => {
  return {
    Auth: {
      Cognito: {
        userPoolClientId: "1jc6b0tlmqic0bhtu34p122qgk",
        userPoolId: "us-east-1_pWKGHHMDU",
        loginWith: {
          // Optional
          oauth: {
            domain: "finn-prod.auth.us-east-1.amazoncognito.com",
            scope: ["openid"],
            redirectSignIn: callbackURL,
            redirectSignOut: callbackURL,
            responseType: "code",
          },
          username: "true",
          email: "false", // Optional
          phone: "false", // Optional
        },
      },
    },
    oauth: {
      domain: "finn-prod.auth.us-east-1.amazoncognito.com",
      scope: ["openid"],
      redirectSignIn: callbackURL,
      redirectSignOut: callbackURL,
      responseType: "code",
    },
    // Cognito options
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:97bd0593-3c7e-4176-801d-06fc31e4ab5b",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_pWKGHHMDU",
    aws_user_pools_web_client_id: "1jc6b0tlmqic0bhtu34p122qgk",
    // AppSync
    aws_appsync_graphqlEndpoint:
      "https://6mfnfj77sbaqdiergb3nevxwzu.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    API: {
      graphql_endpoint:
        "https://6mfnfj77sbaqdiergb3nevxwzu.appsync-api.us-east-1.amazonaws.com/graphql",
      graphql_headers: async () => ({ Authorization: "", AuthUser: "" }),
    },
  };
};

export const getAlpha2Config = (callbackURL: string) => {
  return {
    Auth: {
      Cognito: {
        userPoolClientId: "74fhn2a1jeelak5fcksjhrd6fk",
        userPoolId: "us-east-1_i3M2dkMur",
        loginWith: {
          oauth: {
            domain: "finn-alpha-2.auth.us-east-1.amazoncognito.com",
            scope: ["openid"],
            redirectSignIn: callbackURL,
            redirectSignOut: callbackURL,
            responseType: "code",
          },
          username: "true",
          email: "false",
          phone: "false",
        },
      },
    },
    oauth: {
      domain: "finn-alpha-2.auth.us-east-1.amazoncognito.com",
      scope: ["openid"],
      redirectSignIn: callbackURL,
      redirectSignOut: callbackURL,
      responseType: "code",
    },
    aws_project_region: "us-east-1",
    aws_cognito_identity_pool_id:
      "us-east-1:00a06d50-6f53-4aec-a2e2-456644057379",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_i3M2dkMur",
    aws_user_pools_web_client_id: "74fhn2a1jeelak5fcksjhrd6fk",
    aws_appsync_graphqlEndpoint:
      "https://e43kpkycqjbgha6moerifrreq4.appsync-api.us-east-1.amazonaws.com/graphql",
    aws_appsync_region: "us-east-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    API: {
      graphql_endpoint:
        "https://e43kpkycqjbgha6moerifrreq4.appsync-api.us-east-1.amazonaws.com/graphql",
      graphql_headers: async () => ({ Authorization: "", AuthUser: "" }),
    },
  };
};
export const getAmplifyConfig = (url: string) => {
  if (url.includes("prod")) {
    return getProdConfig(url);
  }
  if (url.includes("gamma")) {
    return getGammaConfig(url);
  }
  // Alpha cell 2 - update Cognito/AppSync values after first deployment
  if (url.includes("alpha-2")) {
    return getAlpha2Config(url);
  }
  return getAlphaConfig(url);
};
